import { render, staticRenderFns } from "./BankOrderCRUD.vue?vue&type=template&id=3e84a548"
import script from "./BankOrderCRUD.vue?vue&type=script&lang=js"
export * from "./BankOrderCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports